/**
 * All icons from the design are available here.
 *
 * @remarks
 * To add more icons, @see Chakra-Icons @link {https://chakra-ui.com/docs/components/icon/usage}
 * If unavailable, copy SVG of the unavailable icon from Figma and create here.
 */

import { createIcon } from "@chakra-ui/react";
import _ from "lodash";

export const SurveyUnlockedIcon = createIcon({
  displayName: "SurveyUnlockedIcon",
  viewBox: "0 0 30 35",
  path: [
    <path
      key={_.uniqueId()}
      d="M24.6143 16.5H5.36426C3.84547 16.5 2.61426 17.8431 2.61426 19.5V30C2.61426 31.6569 3.84547 33 5.36426 33H24.6143C26.133 33 27.3643 31.6569 27.3643 30V19.5C27.3643 17.8431 26.133 16.5 24.6143 16.5Z"
      stroke="#F8F8F8"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={_.uniqueId()}
      d="M8.11324 16.4997V10.4997C8.11153 8.63981 8.74338 6.84554 9.88613 5.46524C11.0289 4.08494 12.601 3.2171 14.2973 3.03018C15.9936 2.84326 17.6931 3.3506 19.0658 4.45371C20.4385 5.55683 21.3865 7.17701 21.7257 8.99974"
      stroke="#F8F8F8"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});

export const SurveyLockedIcon = createIcon({
  displayName: "SurveyLockedIcon",
  viewBox: "0 0 31 34",
  path: [
    <path
      key={_.uniqueId()}
      d="M25.5643 15.5H5.25401C3.65157 15.5 2.35254 16.8431 2.35254 18.5V29C2.35254 30.6569 3.65157 32 5.25401 32H25.5643C27.1668 32 28.4658 30.6569 28.4658 29V18.5C28.4658 16.8431 27.1668 15.5 25.5643 15.5Z"
      stroke="#1D4044"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={_.uniqueId()}
      d="M8.15527 15.5V9.5C8.15527 7.51088 8.9195 5.60322 10.2798 4.1967C11.6402 2.79018 13.4852 2 15.409 2C17.3328 2 19.1778 2.79018 20.5381 4.1967C21.8984 5.60322 22.6626 7.51088 22.6626 9.5V15.5"
      stroke="#1D4044"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});

export const InfoIcon = createIcon({
  displayName: "InfoIcon",
  viewBox: "0 0 36 36",
  path: [
    <path
      key={_.uniqueId()}
      d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33Z"
      stroke="#E6FFFA"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={_.uniqueId()}
      d="M18 24V18"
      stroke="#E6FFFA"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={_.uniqueId()}
      d="M18 12H18.015"
      stroke="#E6FFFA"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});

export const MailIcon = createIcon({
  displayName: "MailIcon",
  viewBox: "0 0 26 22",
  path: [
    <path
      key={_.uniqueId()}
      d="M3.66666 1.94214H22.3333C23.6167 1.94214 24.6667 2.99214 24.6667 4.27547V18.2755C24.6667 19.5588 23.6167 20.6088 22.3333 20.6088H3.66666C2.38333 20.6088 1.33333 19.5588 1.33333 18.2755V4.27547C1.33333 2.99214 2.38333 1.94214 3.66666 1.94214Z"
      stroke="#0C0C0C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={_.uniqueId()}
      d="M24.6667 4.27539L13 12.4421L1.33333 4.27539"
      stroke="#0C0C0C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});

export const ClockIcon = createIcon({
  displayName: "ClockIcon",
  viewBox: "0 0 37 35",
  path: [
    <path
      key={_.uniqueId()}
      d="M18.525 32.2754C27.3872 32.2754 34.5715 25.5597 34.5715 17.2754C34.5715 8.99112 27.3872 2.27539 18.525 2.27539C9.66278 2.27539 2.47852 8.99112 2.47852 17.2754C2.47852 25.5597 9.66278 32.2754 18.525 32.2754Z"
      stroke="#1D4044"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={_.uniqueId()}
      d="M18.5244 8.27539V17.2754L24.943 20.2754"
      stroke="#1D4044"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});

export const FiltersIcon = createIcon({
  displayName: "FiltersIcon",
  viewBox: "0 0 25 25",
  path: (
    <path
      d="M1.15039 4.73092H12.5694C12.9135 6.29743 14.3125 7.47348 15.9808 7.47348C17.6492 7.47348 19.0482 6.29748 19.3923 4.73092H23.6504C24.0646 4.73092 24.4004 4.39511 24.4004 3.98092C24.4004 3.56673 24.0646 3.23092 23.6504 3.23092H19.3919C19.0471 1.6652 17.6463 0.488403 15.9808 0.488403C14.3145 0.488403 12.9143 1.66501 12.5697 3.23092H1.15039C0.736203 3.23092 0.400391 3.56673 0.400391 3.98092C0.400391 4.39511 0.736203 4.73092 1.15039 4.73092ZM13.9884 3.98289C13.9884 3.98022 13.9884 3.9775 13.9884 3.97483C13.9917 2.8795 14.8855 1.98845 15.9808 1.98845C17.0747 1.98845 17.9685 2.87828 17.9732 3.97309L17.9734 3.98411C17.9716 5.08131 17.0785 5.97353 15.9808 5.97353C14.8837 5.97353 13.9908 5.0822 13.9883 3.98565L13.9884 3.98289ZM23.6504 20.2691H19.3919C19.0471 18.7034 17.6463 17.5266 15.9808 17.5266C14.3145 17.5266 12.9143 18.7032 12.5697 20.2691H1.15039C0.736203 20.2691 0.400391 20.6049 0.400391 21.0191C0.400391 21.4333 0.736203 21.7691 1.15039 21.7691H12.5694C12.9135 23.3356 14.3125 24.5117 15.9808 24.5117C17.6492 24.5117 19.0482 23.3356 19.3923 21.7691H23.6504C24.0646 21.7691 24.4004 21.4333 24.4004 21.0191C24.4004 20.6049 24.0646 20.2691 23.6504 20.2691ZM15.9808 23.0117C14.8837 23.0117 13.9908 22.1203 13.9883 21.0238L13.9884 21.0211C13.9884 21.0183 13.9884 21.0157 13.9884 21.013C13.9917 19.9177 14.8855 19.0266 15.9808 19.0266C17.0747 19.0266 17.9685 19.9164 17.9732 21.0112L17.9734 21.0222C17.9718 22.1195 17.0786 23.0117 15.9808 23.0117ZM23.6504 11.75H12.2314C11.8872 10.1835 10.4883 9.00751 8.81994 9.00751C7.15156 9.00751 5.75262 10.1835 5.40847 11.75H1.15039C0.736203 11.75 0.400391 12.0858 0.400391 12.5C0.400391 12.9143 0.736203 13.25 1.15039 13.25H5.40884C5.7537 14.8157 7.15452 15.9925 8.81994 15.9925C10.4862 15.9925 11.8865 14.8159 12.2311 13.25H23.6504C24.0646 13.25 24.4004 12.9143 24.4004 12.5C24.4004 12.0858 24.0646 11.75 23.6504 11.75ZM10.8124 12.4981C10.8124 12.5008 10.8124 12.5034 10.8124 12.5061C10.8091 13.6014 9.91531 14.4925 8.81994 14.4925C7.72611 14.4925 6.8323 13.6027 6.82756 12.5079L6.82742 12.4969C6.82906 11.3996 7.72227 10.5075 8.81994 10.5075C9.91709 10.5075 10.81 11.3988 10.8125 12.4954L10.8124 12.4981Z"
      fill="white"
    />
  ),
});

export const LocationPinIcon = createIcon({
  displayName: "LocationPinIcon",
  viewBox: "0 0 21 25",
  path: [
    <path
      key={_.uniqueId()}
      d="M19.4004 10.5C19.4004 17.5 10.4004 23.5 10.4004 23.5C10.4004 23.5 1.40039 17.5 1.40039 10.5C1.40039 8.11305 2.3486 5.82387 4.03643 4.13604C5.72426 2.44821 8.01344 1.5 10.4004 1.5C12.7873 1.5 15.0765 2.44821 16.7644 4.13604C18.4522 5.82387 19.4004 8.11305 19.4004 10.5Z"
      stroke="#F8F8F8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={_.uniqueId()}
      d="M10.4004 13.5C12.0572 13.5 13.4004 12.1569 13.4004 10.5C13.4004 8.84315 12.0572 7.5 10.4004 7.5C8.74354 7.5 7.40039 8.84315 7.40039 10.5C7.40039 12.1569 8.74354 13.5 10.4004 13.5Z"
      stroke="#F8F8F8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});

export const SurveyCompleteIcon = createIcon({
  displayName: "SurveyCompleteIcon",
  viewBox: "0 0 34 35",
  path: [
    <path
      key={_.uniqueId()}
      d="M31.9161 16.6208V18.0008C31.9143 21.2354 30.9013 24.3828 29.0282 26.9735C27.155 29.5642 24.5221 31.4595 21.5221 32.3766C18.5221 33.2938 15.3157 33.1836 12.3812 32.0626C9.44663 30.9417 6.94117 28.8699 5.23845 26.1564C3.53573 23.4428 2.72698 20.2329 2.93281 17.0052C3.13865 13.7776 4.34805 10.7053 6.38064 8.24638C8.41323 5.7875 11.1601 4.07385 14.2116 3.36099C17.2631 2.64814 20.4557 2.97428 23.3132 4.29077"
      stroke="#1D4044"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={_.uniqueId()}
      d="M31.9162 6L17.4089 21.015L13.0566 16.515"
      stroke="#1D4044"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});

export const ViewPasswordIcon = createIcon({
  displayName: "ViewPasswordIcon",
  viewBox: "0 0 25 19",
  path: [
    <path
      key={_.uniqueId()}
      d="M1.53027 9.97852C1.53027 9.97852 5.53027 1.97852 12.5303 1.97852C19.5303 1.97852 23.5303 9.97852 23.5303 9.97852C23.5303 9.97852 19.5303 17.9785 12.5303 17.9785C5.53027 17.9785 1.53027 9.97852 1.53027 9.97852Z"
      stroke="black"
      strokeOpacity="0.64"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={_.uniqueId()}
      d="M12.5303 12.9785C14.1871 12.9785 15.5303 11.6354 15.5303 9.97852C15.5303 8.32166 14.1871 6.97852 12.5303 6.97852C10.8734 6.97852 9.53027 8.32166 9.53027 9.97852C9.53027 11.6354 10.8734 12.9785 12.5303 12.9785Z"
      stroke="black"
      strokeOpacity="0.64"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});

export const HidePasswordIcon = createIcon({
  displayName: "HidePasswordIcon",
  viewBox: "0 0 25 24",
  path: [
    <path
      key={_.uniqueId()}
      d="M10.6109 4.24002C11.2993 4.0789 12.004 3.99836 12.7109 4.00003C19.7109 4.00003 23.7109 12 23.7109 12C23.1039 13.1356 22.38 14.2048 21.5509 15.19M14.8309 14.12C14.5563 14.4148 14.2251 14.6512 13.8571 14.8151C13.4891 14.9791 13.0918 15.0673 12.689 15.0744C12.2862 15.0815 11.8861 15.0074 11.5125 14.8565C11.139 14.7056 10.7997 14.4811 10.5148 14.1962C10.2299 13.9113 10.0053 13.572 9.85445 13.1984C9.70356 12.8249 9.62946 12.4247 9.63657 12.0219C9.64368 11.6191 9.73185 11.2219 9.89581 10.8539C10.0598 10.4859 10.2962 10.1547 10.5909 9.88003M18.6509 17.94C16.9415 19.243 14.86 19.9649 12.7109 20C5.71094 20 1.71094 12 1.71094 12C2.95483 9.68192 4.68007 7.65663 6.77094 6.06003L18.6509 17.94Z"
      stroke="black"
      strokeOpacity="0.64"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key={_.uniqueId()}
      d="M1.71094 1L23.7109 23"
      stroke="black"
      strokeOpacity="0.64"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});

export const LikeIcon = createIcon({
  displayName: "ThumbsUpIcon",
  viewBox: "0 0 20 20",
  path: [
    <path
      key={_.uniqueId()}
      d="M5.83464 18.3327H3.33464C2.89261 18.3327 2.46868 18.1571 2.15612 17.8445C1.84356 17.532 1.66797 17.108 1.66797 16.666V10.8327C1.66797 10.3907 1.84356 9.96673 2.15612 9.65417C2.46868 9.34161 2.89261 9.16602 3.33464 9.16602H5.83464M11.668 7.49935V4.16602C11.668 3.50297 11.4046 2.86709 10.9357 2.39825C10.4669 1.92941 9.83101 1.66602 9.16797 1.66602L5.83464 9.16602V18.3327H15.2346C15.6366 18.3372 16.0266 18.1964 16.3329 17.936C16.6392 17.6757 16.841 17.3134 16.9013 16.916L18.0513 9.41602C18.0876 9.17715 18.0714 8.93325 18.0041 8.70122C17.9367 8.4692 17.8197 8.25459 17.6612 8.07228C17.5026 7.88996 17.3064 7.74429 17.0859 7.64536C16.8655 7.54644 16.6262 7.49661 16.3846 7.49935H11.668Z"
      stroke="#1D4044"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});

export const DislikeIcon = createIcon({
  displayName: "ThumbsUpIcon",
  viewBox: "0 0 20 20",
  path: [
    <path
      key={_.uniqueId()}
      d="M14.1652 1.66632H16.3902C16.8619 1.65798 17.3201 1.8231 17.6781 2.13033C18.036 2.43757 18.2687 2.86553 18.3319 3.33298V9.16632C18.2687 9.63377 18.036 10.0617 17.6781 10.369C17.3201 10.6762 16.8619 10.8413 16.3902 10.833H14.1652M8.33189 12.4997V15.833C8.33189 16.496 8.59529 17.1319 9.06413 17.6008C9.53297 18.0696 10.1689 18.333 10.8319 18.333L14.1652 10.833V1.66632H4.76523C4.36329 1.66177 3.97325 1.80265 3.66697 2.06298C3.3607 2.32331 3.15883 2.68556 3.09856 3.08298L1.94856 10.583C1.9123 10.8219 1.92842 11.0657 1.99578 11.2978C2.06314 11.5298 2.18014 11.7444 2.33868 11.9267C2.49721 12.109 2.69349 12.2547 2.91392 12.3536C3.13434 12.4526 3.37364 12.5024 3.61523 12.4997H8.33189Z"
      stroke="#1D4044"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});

export const HeartIcon = createIcon({
  displayName: "HeartIcon",
  viewBox: "0 0 24 24",
  path: [
    <path
      key={_.uniqueId()}
      d="M20.8382 4.60987C20.3274 4.09888 19.721 3.69352 19.0535 3.41696C18.3861 3.14039 17.6707 2.99805 16.9482 2.99805C16.2257 2.99805 15.5103 3.14039 14.8428 3.41696C14.1754 3.69352 13.5689 4.09888 13.0582 4.60987L11.9982 5.66987L10.9382 4.60987C9.90647 3.57818 8.5072 2.99858 7.04817 2.99858C5.58913 2.99858 4.18986 3.57818 3.15817 4.60987C2.12647 5.64156 1.54688 7.04084 1.54688 8.49987C1.54687 9.95891 2.12647 11.3582 3.15817 12.3899L4.21817 13.4499L11.9982 21.2299L19.7782 13.4499L20.8382 12.3899C21.3492 11.8791 21.7545 11.2727 22.0311 10.6052C22.3076 9.93777 22.45 9.22236 22.45 8.49987C22.45 7.77738 22.3076 7.06198 22.0311 6.39452C21.7545 5.72706 21.3492 5.12063 20.8382 4.60987V4.60987Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});

export const HeartOulinedIcon = createIcon({
  displayName: "HeartIcon",
  viewBox: "0 0 24 24",
  path: [
    <path
      key={_.uniqueId()}
      d="M21.1292 4.60987C20.6184 4.09888 20.012 3.69352 19.3445 3.41696C18.6771 3.14039 17.9617 2.99805 17.2392 2.99805C16.5167 2.99805 15.8013 3.14039 15.1338 3.41696C14.4664 3.69352 13.8599 4.09888 13.3492 4.60987L12.2892 5.66987L11.2292 4.60987C10.1975 3.57818 8.79821 2.99858 7.33918 2.99858C5.88015 2.99858 4.48087 3.57818 3.44918 4.60987C2.41749 5.64156 1.83789 7.04084 1.83789 8.49987C1.83789 9.95891 2.41749 11.3582 3.44918 12.3899L4.50918 13.4499L12.2892 21.2299L20.0692 13.4499L21.1292 12.3899C21.6402 11.8791 22.0455 11.2727 22.3221 10.6052C22.5987 9.93777 22.741 9.22236 22.741 8.49987C22.741 7.77738 22.5987 7.06198 22.3221 6.39452C22.0455 5.72706 21.6402 5.12063 21.1292 4.60987V4.60987Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});
